import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import A from '../A';
import styles from './styles';
var useStyles = createUseStyles(styles);
var BackLink = function BackLink(props) {
  var classesProp = props.classes,
    className = props.className,
    linkProps = props.linkProps,
    children = props.children;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  if (!linkProps) {
    return null;
  }
  return /*#__PURE__*/React.createElement(A, _extends({
    className: cx(classes.container, className)
  }, linkProps), "\u2039", ' ', children);
};
BackLink.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  linkProps: PropTypes.shape(A.propTypes),
  children: PropTypes.node.isRequired
};
BackLink.defaultProps = {
  className: null,
  classes: {},
  linkProps: null
};
export default withMemo()(BackLink);